export type AbsenceType = "betoblik" | "yillik" | "ma_muriy" | "ijodiy" | "tugruq" | "boshqa";

export type AbsenceStatus = "kutilmoqda" | "tasdiqlangan" | "rad_etilgan" | "bekor_qilingan";

export interface Absence {
	id: string;
	employeeId: string;
	type: AbsenceType;
	dateFrom: string;
	dateTo: string;
	documentFileId: string | null;
	status: AbsenceStatus;
	requestedBy: string | null;
	reason: string | null;
	reviewedBy: string | null;
	reviewedAt: string | null;
	reviewNote: string | null;
	createdAt: string;
	updatedAt: string;
}

export interface AbsenceCreateInput {
	employeeId: string;
	type: AbsenceType;
	dateFrom: string;
	dateTo: string;
	reason?: string;
	documentFileId?: string;
}

export type AbsenceReviewAction = "approve" | "reject" | "cancel";

/**
 * ⚠️ **BU IKKI EXPORT O'CHIRILMAYDI** — `@/modules/employees`
 * (`employeeTabs.tsx`, `RecentAbsencesCard.tsx`) ularni TO'G'RIDAN-TO'G'RI
 * import qiladi (izoh: "qo'shni moduldan yorliq lug'ati import qilinadi,
 * hook emas — nusxalash ikki ro'yxatni jimgina ajratardi"). P7 §8 doirasi
 * FAQAT `absences`/`accountDeletion`/`audit` — `employees` ni tahrirlash
 * taqiqlangan, ya'ni bu lug'at o'zbekcha matn bilan QOLADI. Bu modulning
 * O'Z komponentlari esa pastdagi `ABSENCE_TYPE_VALUES`/`ABSENCE_STATUS_VALUES`
 * + `useTranslation("absences")` orqali `t(\`type.${value}\`)` ishlatadi.
 */
export const ABSENCE_TYPE_LABELS: Record<AbsenceType, string> = {
	betoblik: "Betoblik",
	yillik: "Yillik ta'til",
	ma_muriy: "Ma'muriy",
	ijodiy: "Ijodiy",
	tugruq: "Tug'ruq",
	boshqa: "Boshqa",
};

export const ABSENCE_STATUS_LABELS: Record<AbsenceStatus, { label: string; color: string }> = {
	kutilmoqda: { label: "Kutilmoqda", color: "blue" },
	tasdiqlangan: { label: "Tasdiqlangan", color: "green" },
	rad_etilgan: { label: "Rad etilgan", color: "red" },
	bekor_qilingan: { label: "Bekor qilingan", color: "default" },
};

/**
 * Shu modulning O'Z komponentlari uchun (P7 spec §8) — qiymatlar tartibi
 * (Select opsiyalari) va status rangi; ko'rinadigan matn
 * `useTranslation("absences")` + `t(\`type.${value}\`)` / `t(\`status.${value}\`)`
 * orqali olinadi, bu yerda saqlanmaydi.
 */
export const ABSENCE_TYPE_VALUES: AbsenceType[] = [
	"betoblik",
	"yillik",
	"ma_muriy",
	"ijodiy",
	"tugruq",
	"boshqa",
];

export const ABSENCE_STATUS_VALUES: AbsenceStatus[] = [
	"kutilmoqda",
	"tasdiqlangan",
	"rad_etilgan",
	"bekor_qilingan",
];

export const ABSENCE_STATUS_COLORS: Record<AbsenceStatus, string> = {
	kutilmoqda: "blue",
	tasdiqlangan: "green",
	rad_etilgan: "red",
	bekor_qilingan: "default",
};
